import React from 'react'
import { Outlet } from 'react-router-dom'

const NotificationManagementOutlet = () => {
  return (
    <>
      <Outlet/> 
    </>
  )
}

export default NotificationManagementOutlet
